import { useReveal } from "@/lib/useReveal";

const ROWS = [
    {
        stage: "Точка А",
        what: "Фиксируем стартовую ситуацию",
        how: "Диагностика процессов, метрик, людей. Совместная карта рисков и приоритетов.",
        who: "Я + собственник",
    },
    {
        stage: "Цели",
        what: "Договариваемся о результате",
        how: "Описываем измеримые ориентиры на горизонт работы. Что именно изменится в ИТ-блоке.",
        who: "Собственник",
    },
    {
        stage: "Карта результата",
        what: "Превращаем цели в маршрут",
        how: "Декомпозиция в этапы с критериями приёмки, точками контроля и ответственными.",
        who: "Я",
    },
    {
        stage: "Сверка",
        what: "Контроль раз в 2 недели",
        how: "Короткий ритуал: что сделали, где буксуем, что меняем в Карте. Без отчётов ради отчётов.",
        who: "Я + команда",
    },
    {
        stage: "Точка Б",
        what: "Фиксируем итог",
        how: "Сравниваем результат с Картой. Передаю процессы внутрь команды.",
        who: "Я + собственник",
    },
];

export const Results = () => {
    const ref = useReveal();
    return (
        <section
            id="results"
            data-testid="results-section"
            className="relative py-28 sm:py-40 bg-[#F4F1EA] border-t border-[#1B2A41]/15 overflow-hidden"
        >
            <div className="absolute inset-0 vnutri-grid-bg opacity-60 -z-10" />

            <div ref={ref} className="vnutri-reveal max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-20 mb-20">
                    <div className="lg:col-span-7">
                        <div className="flex items-center gap-4 mb-6">
                            <span className="w-12 h-px bg-[#C46342]" />
                            <span className="text-[11px] tracking-[0.4em] uppercase font-semibold text-[#C46342]">
                                03 · Метод
                            </span>
                        </div>
                        <h2
                            data-testid="results-title"
                            className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl tracking-[-0.03em] text-[#1B2A41] font-extralight leading-[1.02]"
                        >
                            Как мы контролируем{" "}
                            <span className="font-semibold">результат</span>
                        </h2>
                    </div>
                    <div className="lg:col-span-5 lg:pt-8">
                        <p className="text-lg sm:text-xl leading-[1.6] text-[#1B2A41]/80 font-light">
                            Мне важно, чтобы в конце было очевидно, что изменилось и почему. Для этого, независимо от выбранного формата, до начала работ мы вместе формируем Карту результата — документ, который мы ведём и обновляем каждые две недели.
                        </p>
                    </div>
                </div>

                {/* Technical grid */}
                <div className="border border-[#1B2A41]/15 bg-white">
                    <div className="hidden lg:grid grid-cols-12 text-[10px] tracking-[0.32em] uppercase font-semibold text-[#1B2A41]/50 border-b border-[#1B2A41]/15">
                        <div className="col-span-2 px-6 py-4 border-r border-[#1B2A41]/15">
                            Этап
                        </div>
                        <div className="col-span-3 px-6 py-4 border-r border-[#1B2A41]/15">
                            Что фиксируем
                        </div>
                        <div className="col-span-5 px-6 py-4 border-r border-[#1B2A41]/15">
                            Как именно
                        </div>
                        <div className="col-span-2 px-6 py-4">Кто</div>
                    </div>

                    {ROWS.map((row, i) => (
                        <div
                            key={i}
                            data-testid={`result-row-${i}`}
                            className="group grid grid-cols-1 lg:grid-cols-12 hover:bg-[#F4F1EA] transition-colors border-b last:border-b-0 border-[#1B2A41]/10"
                        >
                            <div className="col-span-2 px-6 py-6 lg:py-8 lg:border-r border-[#1B2A41]/10 flex items-center gap-3">
                                <span className="w-2 h-2 bg-[#C46342] shrink-0 group-hover:scale-125 transition-transform" />
                                <span className="text-base font-semibold tracking-tight text-[#1B2A41]">
                                    {row.stage}
                                </span>
                            </div>
                            <div className="col-span-3 px-6 py-2 lg:py-8 lg:border-r border-[#1B2A41]/10 text-base text-[#1B2A41]">
                                {row.what}
                            </div>
                            <div className="col-span-5 px-6 py-2 lg:py-8 lg:border-r border-[#1B2A41]/10 text-sm leading-relaxed text-[#1B2A41]/75">
                                {row.how}
                            </div>
                            <div className="col-span-2 px-6 py-6 lg:py-8 text-xs tracking-[0.18em] uppercase text-[#1B2A41]/60">
                                {row.who}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-10 max-w-4xl">
                    <p
                        data-testid="results-closing"
                        className="text-base sm:text-lg leading-[1.7] text-[#1B2A41]/85 font-light"
                    >
                        Один документ — для собственника, команды и меня. Сверка раз в две недели, корректировка маршрута до того, как срок станет проблемой. В конце работы Карта остаётся внутри компании как рабочий операционный артефакт, который показывает наше движение из начальной точки А до желаемой точки Б.
                    </p>
                </div>
            </div>
        </section>
    );
};
